import localForage from 'localforage';
import _ from 'lodash';
import Promise from 'bluebird'
import {EMPTY} from "rxjs";
import {auditTime, catchError, switchMap} from "rxjs/operators";
import {getAppDiscriminator, getAppInst} from "util/AppName"
import {getCurrentUserGroupId, getCurrentUserId} from 'module/SessionInfo/api/SessionInfoAPI';
import {upgradeReduxState} from 'util/redux/ReduxStateUpgrader';
import {log} from 'common/log'
import {Epic} from 'redux-observable'

function getStateId() {
	const parts = [
		'Redux',
		getCurrentUserId(),
		getCurrentUserGroupId(),
		getAppDiscriminator(),
	]
	const appinst = getAppInst()
	if (appinst?.trim()) parts.push(appinst)
	return parts.join('/')
}

const getGlobalStateId = () => [
	'Global',
	getCurrentUserId(),
	getCurrentUserGroupId(),
].join('/');

const GloballyDisabledNamespaces = [
	'AjaxStatus',
	'DqButton.transient',
	'EntryDesc.favEditMode',
	'EventDialog',
	'Kost.fetched',
	'Modal.SessionInfo.open',
	'Modal.AppVersionInfo.open',
	'MultiEdit',
	'Noti.open',
	'SessionInfo.data',
	'TopNavBar',
];

const GlobalStorage = [
	'Menu',
	'Modal.SessionInfo',
	'Modal.NotiDrawer',
	'Noti',
	'Theme.global',
	'UserConfig.SessionInfo',
];

let blockSaveToLocalStorage = false;

export function criticalErrorBlockSaveState() {
	blockSaveToLocalStorage = true
}

function mergeGlobalState(appState: object, globalState: object) {
	GlobalStorage.forEach(key => _.set(appState, key, _.get(globalState, key)))
	return appState
}

export function requestRemoveAppStateFromLocalStorage() {
	blockSaveToLocalStorage = true;
	// do not use react confirm dialog, because it may be crashed
	if (confirm(
		'Sind sie sich sicher, dass sie ihre lokalen, persönlichen Einstellungen dieser Applikation zurücksetzen wollen?',
	)) {
		removeAppStateFromLocalStorage().then(() => setTimeout(() => window.location.reload(), 800));
	} else {
		blockSaveToLocalStorage = false;
	}
}

export const removeAppStateFromLocalStorage = () => Promise.all([
	localForage.removeItem(getStateId()),
	localForage.removeItem(getGlobalStateId()),
])

export const loadUpgradedStateFromLocalStorage = () =>
	Promise.all([localForage.getItem(getGlobalStateId()), localForage.getItem(getStateId())])
		.then(([globalState, appState]: [object, object]) => upgradeReduxState(mergeGlobalState(appState, globalState)))
		.catch(err => {
			log.error("Error loading store: ", err);
			return undefined;
		})

const persistState = (state: object) => {
	if (blockSaveToLocalStorage) return;
	state = _.omit(state, GloballyDisabledNamespaces);
	return localForage.setItem(
		getStateId(),
		_.omit(state, GlobalStorage),
	).then(() =>
		localForage.setItem(
			getGlobalStateId(),
			_.pick(state, GlobalStorage),
		));
};

export const persistStateToClientStorageEpic: Epic = (action$, state$) => action$.pipe(
	auditTime(1500),
	switchMap(() => persistState(state$.value) || Promise.reject("nothing returned from persistState")),
	catchError(err => {
		log.error(err);
		return EMPTY;
	}),
	switchMap(() => EMPTY),
);
